import React, { useEffect } from "react";
import PlaygroundArea from "layouts/Playground/PlaygroundArea";
import ProductGrid from "./ProductGrid";
import CodeHistoryGrid from "./CodeHistoryGrid";
import UserProgress from "./UserProgress";
import GlobalTimeline from "./GlobalTimeline";
import { useDispatch, useSelector } from "react-redux";
import { selectIsGameOver, selectPlayCount } from "store/game/selectors";
import GameOver from "./GameOver";
import { exitGame } from "store/game";

export default function Playground() {
  const dispatch = useDispatch();
  const playCount = useSelector(selectPlayCount);
  const isGameOver = useSelector(selectIsGameOver);

  useEffect(() => {
    return () => {
      dispatch(exitGame());
    };
  }, [dispatch]);

  return (
    <div
      key={playCount}
      className="playground-grid h-full w-full max-w-[1440px] max-h-[760px] p-4"
    >
      <PlaygroundArea name="products">
        {isGameOver ? <GameOver /> : <ProductGrid />}
      </PlaygroundArea>
      <PlaygroundArea className="hidden lg:block overflow-auto" name="codes">
        <CodeHistoryGrid />
      </PlaygroundArea>
      <PlaygroundArea name="progress">
        <UserProgress />
      </PlaygroundArea>
      <PlaygroundArea name="timeline">
        <GlobalTimeline />
      </PlaygroundArea>
      {/* <GameOver /> */}
    </div>
  );
}
